<template>
  <div>
    <v-card>
      <v-row justify="space-between" align="center">
        <v-col cols="auto">
          <v-card-title>Keywords Table</v-card-title>
        </v-col>
        <v-col cols="auto" class="mr-6">
          <v-btn color="primary" @click="addKeywords"
            >Ajouter groupe de Keywords</v-btn
          >
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-data-table class="ml-6 mr-6" :items="items" :headers="headers">
            <template v-slot:item.actions="{ item }">
              <a target="_blank">
                <v-btn
                  class="mx-2"
                  elevation="0"
                  fab
                  small
                  @click="editKeyword(item)"
                >
                  <v-icon color="primary">
                    {{ icons.mdiPencil }}
                  </v-icon>
                </v-btn>
                <v-btn
                  @click="deleteKeyword(item)"
                  class="mx-2"
                  elevation="0"
                  fab
                  small
                >
                  <v-icon color="secondary">
                    {{ icons.mdiTrashCan }}
                  </v-icon>
                </v-btn>
              </a>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>Modifier le groupe de keyword</v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                v-model="keywordsGroup.name"
                label="Nom du groupe de Keywords"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="keywordsGroup.keywords"
                label="Keywords"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card-actions>
                <v-btn color="primary" @click="updateKeywords"
                  >Enregistrer</v-btn
                >
                <v-btn color="secondary" @click="cancelEditKeyword"
                  >Annuler</v-btn
                >
              </v-card-actions>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addKwDialog" max-width="600px">
      <v-card>
        <v-card-title>Ajouter un nouvau groupe de keyword</v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                v-model="keywordsGroup.name"
                label="Nom du groupe de Keywords"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="keywordsGroup.keywords"
                label="Keywords"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card-actions>
                <v-btn color="primary" @click="saveNewKeywords"
                  >Enregistrer</v-btn
                >
                <v-btn color="secondary" @click="cancelEditKeyword"
                  >Annuler</v-btn
                >
              </v-card-actions>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import useAxios from "@/hooks/useAxios";
import { mdiPencil, mdiTrashCan } from "@mdi/js";
export default {
  name: "keywordstable",
  data() {
    return {
      items: [],
      headers: [
        { text: "Name", value: "name" },
        { text: "keywords", value: "keywords" },
        { text: "Actions", value: "actions" },
      ],
      icons: {
        mdiPencil,
        mdiTrashCan,
      },
      dialog: false,
      addKwDialog: false,
      items: [],
      keywordsGroup: {},
    };
  },
  setup() {
    const { axiosPut, axiosGet, axiosPost, axiosDelete, isLoading } =
      useAxios();

    return {
      axiosGet,
      isLoading,
      axiosPost,
      axiosPut,
      axiosDelete,
    };
  },
  created() {
    this.fetchKeywords();
  },
  methods: {
    async fetchKeywords() {
      const response = await this.axiosGet("/gtrends/keywords");
      // console.log("response", response);
      this.items = response.data;
    },
    async editKeyword(item) {
      this.keywordsGroup.id = item.id;
      this.keywordsGroup.name = item.name;
      this.keywordsGroup.keywords = item.keywords;
      console.log(this.keywordsGroup);
      this.dialog = true;
    },
    async cancelEditKeyword() {
      this.dialog = false;
      this.addKwDialog = false;
      this.fetchKeywords();
    },
    async updateKeywords() {
      await this.axiosPut(`gtrends/keywords`, {
        kw_dict: this.keywordsGroup,
      });
      this.dialog = false;
      this.fetchKeywords();
    },
    async deleteKeyword(item) {
      await this.axiosDelete(`gtrends/keywords/${item.id}`);
      this.fetchKeywords();
    },
    addKeywords() {
      this.addKwDialog = true;
    },
    async saveNewKeywords() {
      await this.axiosPost(`gtrends/keywords`, {
        kw_dict: this.keywordsGroup,
      });
      this.addKwDialog = false;
      this.fetchKeywords();
      this.keywordsGroup = {};
    },
  },
};
</script>
<style scoped></style>
